import { makeStyles } from "@material-ui/core/styles";

const inviteUserModalStyles = makeStyles((theme) => ({
  button: {
    backgroundColor: `${theme.palette.secondary.main} !important`,
    width: "200px",
    color: "#fff",
    borderRadius: "10px !important",
    padding: "12px 16px",
    fontSize: "14px",
    fontFamily: "Poppins !important",
  },
  footer: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
  flexCenter: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },

  // invite to project modal styles
  inviteToProjectModalRoot: {
    width: "40%",
    // height: "87%",
    backgroundColor: theme.palette.primary.main,
    borderRadius: "20px",
    padding: "24px",
    boxShadow: "0px 19px 45px 0px #0000001F",
    display: "flex",
    flexDirection: "column",
    gap: "16px",
  },
  title: {
    color: theme.palette.text.primary,
    fontFamily: "Poppins !important",
  },
  cardContentDiv3: {
    backgroundColor: theme.palette.secondary.light,
    padding: "4px",
    borderRadius: "10px",
  },
  cardContentInput1: {
    padding: "0.2px 6px",
    fontFamily: "Poppins !important",
    "& .MuiInputBase-input": {
      padding: "6px",
      backgroundColor: "transparent",
      opacity: 1,
      fontSize: "16px",
      color: "white",
      fontFamily: "poppins",
    },
    "& .MuiOutlinedInput-root": {
      borderRadius: "4px",
      "& fieldset": {
        borderColor: "transparent",
      },
      "&:hover fieldset": {
        borderColor: "transparent",
      },
      "&.Mui-focused fieldset": {
        borderColor: "transparent",
      },
    },
    "&.Mui-disabled .MuiInputBase-input": {
      color: "gray",
    },
  },
  selectRoleDropdown: {
    width: "150px",
    height: "40px",
    backgroundColor: "#252A38",
    color: "#fff",
    borderRadius: "10px",
    border: "none",
    padding: "10px 8px !important",
    "& .MuiSelect-select": {
      color: "#fff",
      display: "flex",
      alignItems: "center",
      gap: "10px",
    },
    "& .MuiSelect-icon": {
      color: "#fff",
    },
    "& .MuiSelect-iconOpen": {
      color: "#fff",
    },
  },
  singleRole: {
    color: "#fff !important",
    display: "flex",
    alignItems: "center",
    gap: "10px",
    fontFamily: "Poppins !important",
  },
}));

export default inviteUserModalStyles;
